module.exports = __webpack_public_path__ + "img/tick-g-icon.b8d660fb.svg";